import useIsInExperiment from '~/hooks/common/experiments/useIsInExperiment';

export default function useIsInInspectionExperiment() {
  return useIsInExperiment(
    'car-merch-ui-vdp-miu-miu-standards-and-150-inspection',
    'treatment'
  );
}
